export interface Surface {
  name: string;
  path: string;
}

export const surfaces: Surface[] = [
  {
    name: "Brand Promotion Performance",
    path: "/brand-promotions-performance",
  },
  { name: "Basic logged-in", path: "/template" },
  { name: "New page", path: "/new-page" },
  { name: "Prototype starter", path: "/prototype-starter" },
  { name: "Insider side cart", path: "/insider-side-cart" },
  { name: "Brand page", path: "/brand" },
  { name: "Search results", path: "/search-results" },
  { name: "PDP", path: "/pdp" },
  { name: "PDP v2", path: "/pdp-v2" },
  { name: "PDP with drawer", path: "/pdp-with-drawer" },
  { name: "PDP with drawer (left)", path: "/pdp-with-drawer-left" },
  { name: "Checkout", path: "/checkout" },
  { name: "Order confirmation", path: "/order-confirmation" },
  {
    name: "Brand Portal — Automations (preview)",
    path: "/fd-invite-as-automation/automations",
  },
];

export const getTitleForPath = (pathname: string): string => {
  if (pathname === "/") {
    return "Design Prototype Playground";
  }

  const surface = surfaces.find((s) => s.path === pathname);
  if (surface) {
    return surface.name;
  }

  if (pathname.startsWith("/brand-promotions-performance/p/")) {
    return "Brand Promotion Performance · Promotion detail";
  }

  return "Design Prototype Playground";
};
